export * from './IMarketingLink';
export * from './IMarketingLinkData';
export * from './ILinkResponse';
